import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { Toast } from '@whelk/components';
import { trackCustomEvent } from '@whelk/utils/src/track';
import useImagePreview from '@whelk/hooks/src/useImagePreview';

import WebImgMask from './Web';
import MobileImgMask from './Mobile';

function download(blob: Blob, filename?: string) {
  const a: any = document.createElement('a');
  a.download = filename;
  const blobUrl = URL.createObjectURL(blob);
  a.href = blobUrl;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(blobUrl);
}

async function downloadFile(url: string, filename?: string) {
  const res = await fetch(url, {
    headers: new Headers({
      Origin: location.origin,
    }),
    mode: 'cors',
  });
  if (res.status !== 200) {
    throw new Error(`status: .`);
  }
  const blob = await res.blob();

  download(blob, filename);
}

function ImgMask() {
  const { t } = useTranslation();

  // 长是否大于宽
  const [isLongMoreThanWide, setIsLongMoreThanWide] = useState<boolean>(false);
  // 组件内部维护图片索引，用来控制切换预览图片
  const [currentImgIndex, setCurrentImgIndex] = useState(0);

  const { closeImagePreview, imgMaskUrl, imgMaskUrlList, imgMaskVisible, eventParams } =
    useImagePreview();

  // 点击图片要关闭预览
  const imgUrl = imgMaskUrlList[currentImgIndex];

  // 计算图片长宽比
  useEffect(() => {
    if (imgUrl) {
      const img = new Image();
      img.src = imgUrl;
      img.onload = () => {
        setIsLongMoreThanWide(img?.width >= img?.height || false);
      };
    }
  }, [currentImgIndex]);

  useEffect(() => {
    const currentIndex = imgMaskUrlList.findIndex((item) => item === imgMaskUrl);
    if (currentIndex !== undefined && imgMaskVisible) setCurrentImgIndex(currentIndex);
  }, [imgMaskVisible]);

  // close
  const onClose = () => {
    closeImagePreview();
  };

  // 点击下载
  const onClickDownLoadImg = async () => {
    let status = 'success';
    try {
      Toast.info(t('toast_downloading'));
      await downloadFile(imgUrl, t('keyboard_image'));
      Toast.success(t('toast_download_success'));
    } catch (e) {
      Toast.error(t('toast_download_fail'));
      status = 'fail';
    }
    if (eventParams?.msgId) {
      trackCustomEvent({
        id: 'pic_download_click',
        msg_id: 'pic_download_click',
        bot_id: eventParams?.botId,
        chat_id: eventParams?.chatId,
        download_type: 'preview',
        download_status: status,
      });
    }
  };

  return process?.env?.NEXT_PUBLIC_ENV === 'web' ? (
    <WebImgMask
      onClose={onClose}
      open={imgMaskVisible}
      imgMaskUrlList={imgMaskUrlList}
      currentImgIndex={currentImgIndex}
      isLongMoreThanWide={isLongMoreThanWide}
      setCurrentImgIndex={setCurrentImgIndex}
      onClickDownLoadImg={onClickDownLoadImg}
    />
  ) : (
    <MobileImgMask
      onClose={onClose}
      open={imgMaskVisible}
      imgMaskUrlList={imgMaskUrlList}
      currentImgIndex={currentImgIndex}
      setCurrentImgIndex={setCurrentImgIndex}
      onClickDownLoadImg={onClickDownLoadImg}
    />
  );
}

export default ImgMask;
